export const topLeftArrowIcon = `
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.799805 8.0154L1.67938 8.01164L1.69467 2.33163L8.55973 9.19666L9.19613 8.56027L2.33276 1.69693L7.99764 1.68138L8.00147 0.799805L1.69934 0.817433L1.6998 0.815403L0.820231 0.819163L0.799805 8.0154Z" fill="#A1A1A1" stroke="#A1A1A1"/>
</svg>
`;
